<template>
  <el-table 
    ref="table" 
    :data="data" 
    v-bind="$attrs" 
    v-on="$listeners" 
    @selection-change="$emit('selection-change', $event)" >
    <slot/>
  </el-table>
</template>
<script>
  export default {
    name: "i-table",
    inheritAttrs: false,
    props: {
      data: {
        type: Array,
        default: () => ([])
      },
      columns: {
        type: Array,
        default: () => ([])
      }
    },
    watch: {
      data() {
        this.$nextTick(() => {
          console.log(this.$refs);
          this.$refs.table.doLayout();
        });
      },
      columns() {
        this.$nextTick(() => {
          console.log(this.$refs);
          this.$refs.table.doLayout();
        });
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/table/index.vue